
     import { getI18n } from '@/lang'
     const i18n = getI18n()
     
import Element from 'element-ui'
export default {
  delConfirm(delObj) {
    Element.MessageBox.confirm(`${i18n.t('thisOperationWillPermanentlyDeleteTheDataDoYouWantToContinue?')}?`, i18n.t(`tips-0`), {
      confirmButtonText: this.$t('deviceBroadcast.submit'),
      cancelButtonText: this.$t('deviceBroadcast.cancel'),
      type: 'warning'
    }).then(() => {
      delObj.onOk()
    })
  }
}

    